<div id="chat_window" class="chat-container">
    <div id="chat_title" class="chat-header" drag>
        <div class="title-area">
            <span>Atendimento {{userName}}</span>
        </div>
        <div class="free-space"></div>
        <div class="title-actions">
            <button nbButton outline status="basic" size="small" style="border:1px solid #fff; color:#fff; margin-left:3px;" (click)="endConversation($event)">
                <nb-icon icon="log-out-outline"></nb-icon>
            </button>
            <button nbButton outline status="basic" size="small" style="border:1px solid #fff; color:#fff; margin-left:3px;" (click)="doClose($event)">
                <nb-icon icon="close-outline"></nb-icon>
            </button>
        </div>
    </div>
    <div class="chat-splash" *ngIf="useQueueSplash">
        <div class="chat-splash-background"></div>
        <div class="chat-splash-body">
            <div class="chat-splash-panel" *ngIf="queueObject.index <= 0 && !queueObject.end">
                <p>Deseja conversar com algum de nossos atendentes?</p>
                <button nbButton shape="round" size="medium" status="success" class="chat-button" (click)="doStartChat($event)">
                    Iniciar Chat
                </button>
            </div>
            <div class="chat-splash-panel" *ngIf="queueObject.index >= 0">
                <p>{{ queueObject.message }}</p>
                <button nbButton shape="round" size="medium" status="default" class="chat-button" (click)="doCancelChat($event)">
                    Encerrar Chat
                </button>
            </div>
            <div class="chat-splash-panel" *ngIf="queueObject.end">
                <p>Atendimento finalizado.</p>
                <button nbButton shape="round" size="medium" status="default" class="chat-button" (click)="doClose($event)">
                    Fechar
                </button>
            </div>
        </div>
    </div>
    <div #scroll class="chat-body">
        <ngx-chat-message *ngFor="let message of messages" [data]="message"></ngx-chat-message>
        <p *ngIf="endByProvider" class="provider-end">Fornecedor encerrou a sessão.</p>
    </div>
    <div class="chat-form">
        <span class="is-typing">{{ isTypingMessage }}</span>
        <div class="chat-group">
            <div class="chat-group-input">
                <input type="text" nbInput fullWidth status="basic" placeholder="Mensagem" [(ngModel)]="text" (keydown.enter)="doSendMessage($event)" (keyup)="doKeyPress($event)" [disabled]="endByProvider">
            </div>
            <div class="chat-group-button">
                <button nbButton status="primary" (click)="doSendMessage($event)" [disabled]="endByProvider">
                    <nb-icon icon="paper-plane-outline"></nb-icon>
                </button>
            </div>
        </div>
    </div>
</div>